import { render, staticRenderFns } from "./HisInfoInstitutionSelector.vue?vue&type=template&id=e307a274&scoped=true&"
import script from "./HisInfoInstitutionSelector.vue?vue&type=script&lang=ts&"
export * from "./HisInfoInstitutionSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e307a274",
  null
  
)

export default component.exports